// js/common/actions/rhubaia-wishlist-button.js
var WishlistButton = class extends HTMLElement {
  constructor() {
    super();
    this.isWishlistPage = false
    this.storageKey = 'rhubaia-wishlist-products'
    this.pageTemplate = 'page.wishlist'
    this.addedClass = 'added-to-wishlist'
    this.products = []
    this.productNodes = {}
    
    this.selectors = {
      productCard: '.product-card',
      wishlistText: '.rhubaia-wishlist-button-text',
    }
    this.isWishlistPage = window?.themeVariables?.settings?.template === this.pageTemplate;
  }

  connectedCallback() {
    this.products = this.getProductsFromStorage();
    this.setWishlistButtonsState();
    this.addEventListener("click", this.onClick.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick.bind(this));
  }

  getProductsFromStorage() {
    try {
      return Array.from(new Set(JSON.parse(localStorage.getItem(this.storageKey)) || []));
    } catch (e) {
      return [];
    }
  }

  setWishlistButtonsState() {
    const handle = this.dataset.productHandle;
    if (!handle) return;

    if (this.products.includes(handle)) {
      this.classList.add(this.addedClass);
    } else {
      this.classList.remove(this.addedClass);
    }
  }

  toggleButtonText(btn) {
    const wishlistText = btn.querySelector(this.selectors.wishlistText);
    if (!wishlistText) return;

    const temp = wishlistText.dataset.revertText;
    wishlistText.dataset.revertText = wishlistText.textContent;
    wishlistText.textContent = temp;
  }

  saveToStorage(products) {
    const unique = Array.from(new Set(products));
    localStorage.setItem(this.storageKey, JSON.stringify(unique));
    this.products = unique;
  }

  onClick(event) {
    event.preventDefault();

    const handle = this.dataset.productHandle;
    if (!handle) return;

    // ✅ always fresh read (avoid stale state)
    const products = this.getProductsFromStorage();

    const isActive = this.classList.contains(this.addedClass);
    const nextActive = !isActive;

    if (nextActive) {
      // add
      if (!products.includes(handle)) products.push(handle);
      this.classList.add(this.addedClass);
    } else {
      // remove
      const updated = products.filter((h) => h !== handle);
      products.length = 0;
      products.push(...updated);
      this.classList.remove(this.addedClass);
    }

    this.saveToStorage(products);
    this.toggleButtonText(this);

    // ✅ wishlist page: remove card from UI (NO extra removeFromWishlist here)
    // if (this.isWishlistPage && !nextActive) {
    //   const prod = this.closest(this.selectors.productCard);
    //   if (prod) prod.remove();
    // }

    // ✅ event (bubbles so document listeners catch it)
    document.documentElement.dispatchEvent(
      new CustomEvent("wishlist:refresh", {
        bubbles: true,
        detail: { products: this.products },
      })
    );
  }

};
if (!window.customElements.get("rhubaia-wishlist-button")) {
  window.customElements.define("rhubaia-wishlist-button", WishlistButton);
}

// js/common/actions/wishlist-dot.js
var WishlistDot = class extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'rhubaia-wishlist-products'
    this.products = []
  }

  connectedCallback() {
    this.products = this.getProductsFromStorage();
    this.updateVisibility();

    // ✅ listen on document (matches the dispatch)
    document.addEventListener("wishlist:refresh", this.onRefresh.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("wishlist:refresh", this.onRefresh.bind(this));
  }

  getProductsFromStorage() {
    try {
      return Array.from(new Set(JSON.parse(localStorage.getItem(this.storageKey)) || []));
    } catch (e) {
      return [];
    }
  }

  onRefresh(event) {
    // take from event if available, else fallback to storage
    const incoming = event?.detail?.products;
    this.products = Array.from(new Set(incoming || this.getProductsFromStorage()));
    this.updateVisibility();
  }

  updateVisibility() {
    this.classList.toggle("is-visible", this.products.length > 0);
  }
};

if (!window.customElements.get("wishlist-dot")) {
  window.customElements.define("wishlist-dot", WishlistDot);
}

// js/common/actions/wishlist-count.js
var WishlistCount = class extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'rhubaia-wishlist-products'
    this.products = []
  }

  connectedCallback() {
    this.products = this.getProductsFromStorage();
    this.updateWishlistCount();

    // ✅ listen on document (matches the dispatch)
    document.addEventListener("wishlist:refresh", this.onRefresh.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("wishlist:refresh", this.onRefresh.bind(this));
  }

  getProductsFromStorage() {
    try {
      return Array.from(new Set(JSON.parse(localStorage.getItem(this.storageKey)) || []));
    } catch (e) {
      return [];
    }
  }

  onRefresh(event) {
    // take from event if available, else fallback to storage
    const incoming = event?.detail?.products;
    this.products = Array.from(new Set(incoming || this.getProductsFromStorage()));
    this.updateWishlistCount();
  }

  updateWishlistCount() {
    this.innerText = this.products.length;
  }
};

if (!window.customElements.get("wishlist-count")) {
  window.customElements.define("wishlist-count", WishlistCount);
}

// js/common/actions/rhubaia-wishlist-empty.js
var WishlistEmpty = class extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'rhubaia-wishlist-products'
    this.products = []
  }

  connectedCallback() {
    this.products = this.getProductsFromStorage();
    this.updateVisibility();

    // ✅ listen on document (matches the dispatch)
    document.addEventListener("wishlist:refresh", this.onRefresh.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("wishlist:refresh", this.onRefresh.bind(this));
  }

  getProductsFromStorage() {
    try {
      return Array.from(new Set(JSON.parse(localStorage.getItem(this.storageKey)) || []));
    } catch (e) {
      return [];
    }
  }

  onRefresh(event) {
    // take from event if available, else fallback to storage
    const incoming = event?.detail?.products;
    this.products = Array.from(new Set(incoming || this.getProductsFromStorage()));
    this.updateVisibility();
  }

  updateVisibility() {
    this.classList.toggle("hidden", this.products.length > 0);
  }
};

if (!window.customElements.get("rhubaia-wishlist-empty")) {
  window.customElements.define("rhubaia-wishlist-empty", WishlistEmpty);
}

// js/common/actions/rhubaia-wishlist-products.js
var WishlistProducts = class extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'rhubaia-wishlist-products'
    this.products = []
  }

  connectedCallback() {
    this.products = this.getProductsFromStorage();
    this.searchQueryString();
    this.loadProducts();

    // ✅ listen on document (matches the dispatch)
    document.addEventListener("wishlist:refresh", this.onRefresh.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("wishlist:refresh", this.onRefresh.bind(this));
  }

  getProductsFromStorage() {
    try {
      return Array.from(new Set(JSON.parse(localStorage.getItem(this.storageKey)) || []));
    } catch (e) {
      return [];
    }
  }

  onRefresh(event) {
    // take from event if available, else fallback to storage
    const incoming = event?.detail?.products;
    this.products = Array.from(new Set(incoming || this.getProductsFromStorage()));
    this.searchQueryString();
    this.loadProducts();
  }

  searchQueryString() {
    const items = this.products;
    return Array.from(items.values(), (item) => `handle:${item}`).join(" OR ");
  }

  extractSectionId(element) {
    element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
    return element.id.replace("shopify-section-", "");
  }

  async loadProducts() {
    const section = this.closest(".shopify-section");
    const url = `${Shopify.routes.root}search?type=product&q=${this.searchQueryString()}&section_id=${this.extractSectionId(section)}`;
    
    const response = await fetch(url, { priority: "low" });
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html");
    const wishlistProductsElement = tempDiv.querySelector("rhubaia-wishlist-products");
    this.replaceChildren(...document.importNode(wishlistProductsElement, true).childNodes);
  }
};

if (!window.customElements.get("rhubaia-wishlist-products")) {
  window.customElements.define("rhubaia-wishlist-products", WishlistProducts);
}